import { useEffect } from "react";

const useFetchOnReconnect = (fetchOlder) => {
    useEffect(() => {
        const handleReconnect = () => {
            fetchOlder(); // Вызываем запрос при восстановлении интернета
        };

        window.addEventListener("online", handleReconnect);
        return () => {
            window.removeEventListener("online", handleReconnect);
        };
    }, [fetchOlder]);
};

export default useFetchOnReconnect;
